var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-input-group el-input-group--prepend" },
    [
      _c(
        "money",
        _vm._b(
          {
            staticClass: "el-input__inner",
            class: {
              desabilitado: _vm.disable,
              "input erro": _vm.hasValidationError
            },
            attrs: {
              maxlength: this.hasLimitValue ? this.hasLimitValue : 12,
              disabled: _vm.disable,
              id: "" + (_vm.propId ? _vm.propId + "-input" : "input-default-id")
            },
            nativeOn: {
              change: function($event) {
                return _vm.change($event)
              },
              blur: function($event) {
                return _vm.change($event)
              }
            },
            model: {
              value: _vm.formattedValue,
              callback: function($$v) {
                _vm.formattedValue = $$v
              },
              expression: "formattedValue"
            }
          },
          "money",
          _vm.money,
          false
        )
      ),
      _vm.showAppend
        ? _c("span", { staticClass: "el-input-group__append" }, [
            _vm._v(_vm._s(_vm.appendText))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f3c3070", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f3c3070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDoubleInput.vue
// module id = null
// module chunks = 